import { createSlice } from '@reduxjs/toolkit';
import { updateSchedule } from "../../api/calendar/update";

export const updateCalendarSlice = createSlice({
    name: 'calendar/update',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateSchedule.pending, (state, action) => {
                state.request = true;
            })
            .addCase(updateSchedule.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(updateSchedule.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload?.message || 'Failed to update schedule';
            })
    },
});

export const { cancelError, showError, showSuccess } = updateCalendarSlice.actions

export default updateCalendarSlice.reducer;
